import React from "react";

import type { SelectChangeEvent } from "@mui/material";

import SettingsTitle from "@app/analytics/account/components/SettingsTitle";
import {
  SettingSectionTitle,
  SwitchControlLabel,
} from "@app/analytics/account/WorkspaceSettings/components/styles";
import WorkspaceCanEditDropdown from "@app/analytics/account/WorkspaceSettings/components/WorkspaceCanEditDropdown";
import UpsellTooltipWrapper from "@app/analytics/components/UpsellTooltipWrapper";
import { TOOLTIPS } from "@app/common/content";
import type { EnterpriseWorkspaceSettings } from "@app/common/workspaces/types";

import { Column } from "@rui/Stack";
import Switch from "@rui/Switch";

const GeneralSettings = ({
  settings,
  onDropdownChange,
  onPreferenceChange,
  workspaceIsInactive,
}: {
  settings: EnterpriseWorkspaceSettings;
  onDropdownChange: (
    settingValue: boolean,
    settingName: keyof EnterpriseWorkspaceSettings
  ) => void;
  onPreferenceChange: (
    preferenceName: keyof EnterpriseWorkspaceSettings,
    type: "toggle" | "value"
  ) => (event: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent) => void;
  workspaceIsInactive: boolean;
}) => {
  return (
    <>
      <SettingSectionTitle>General</SettingSectionTitle>
      <Column spacing={3}>
        <Column spacing={1.5}>
          <UpsellTooltipWrapper show={workspaceIsInactive} placement="right">
            <SwitchControlLabel
              disabled={workspaceIsInactive}
              sx={{ alignItems: "flex-start" }}
              control={
                <Switch
                  checked={settings.affectiveMetricsEnabled}
                  onChange={onPreferenceChange(
                    "affectiveMetricsEnabled",
                    "toggle"
                  )}
                />
              }
              label={
                <SettingsTitle
                  title="Affective metrics"
                  subtitle="Include metrics that calculate engagement, sentiment, charisma, and bias in reports"
                />
              }
            />
          </UpsellTooltipWrapper>
          <WorkspaceCanEditDropdown
            disabled={workspaceIsInactive}
            name="affectiveMetricsEnabledIsUserEditable"
            onUpdate={onDropdownChange}
            selectedValue={settings.affectiveMetricsEnabledIsUserEditable}
            tooltip={
              workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined
            }
          />
        </Column>
        <UpsellTooltipWrapper show={workspaceIsInactive} placement="right">
          <SwitchControlLabel
            disabled={workspaceIsInactive}
            sx={{ alignItems: "flex-start" }}
            control={
              <Switch
                checked={settings.meetingDownloadEnabled}
                onChange={onPreferenceChange(
                  "meetingDownloadEnabled",
                  "toggle"
                )}
              />
            }
            label={
              <SettingsTitle
                title="Downloads"
                subtitle="Allow users to download meeting artifacts (video, transcript, etc.) from the meeting report"
              />
            }
          />
        </UpsellTooltipWrapper>
      </Column>
    </>
  );
};

export default GeneralSettings;
